import { render, staticRenderFns } from "./AuthTerms.vue?vue&type=template&id=2bf7d3ce&"
import script from "./AuthTerms.vue?vue&type=script&lang=ts&"
export * from "./AuthTerms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports